module.exports = __webpack_public_path__ + "static/media/img-11.ab7f70de.jpg";